import { RefreshOutlined } from '@mui/icons-material'
import React, { useEffect, useState } from 'react'
import { NotificationManager } from 'react-notifications'
import BrandService from '../../../../services/brands-service'
import RetailService from '../../../../services/retailService'
import { BrandFilter } from '../../../common/BrandFilter'
import { dataBlocks } from './data'
import './index.css'
import LowStockProducts from './LowStockProducts'
import ProductDistribution from './ProductDistribution'
import StockOverTime from './StockOverTime'
import TopStockProducts from './TopStockProducts'
import WarehouseFilter from './WarehouseFilter'
import WarehouseStockDistribution from './WarehouseStockDistribution'

const RetailAnalyticDashboard = () => {
	const [analyticsData, setAnalyticsData] = useState()
	const [brands, setBrands] = useState([])
	const [stocks_over_time_brand, setStockOverTimeBrand] = useState(null)
	const [selectedWarehouse, setSelectedWarehouse] = useState(null)
	const [warehouses, setWarehouses] = useState([])
	const [lastSyncTime, setLastSyncTime] = useState('N/A')

	useEffect(() => {
		BrandService
			.getBrands({ parent_only: 1 })
			.then((res) => {
				setBrands(res?.brands ?? [])
			})
			.catch(() => {
			})
	}, [])

	useEffect(() => {
		loadAnalyticsData()
	}, [stocks_over_time_brand, selectedWarehouse])

	const loadAnalyticsData = () => {
		let param = {};

		if (stocks_over_time_brand?.value != null && stocks_over_time_brand?.value != 'all') {
			param.stock_over_time_brand = stocks_over_time_brand?.value
		}

		if (selectedWarehouse?.value != null && selectedWarehouse?.value != 'all') {
			param.warehouse = selectedWarehouse?.value
		}

		RetailService.GetInventoryAnalytics(param)
			.then((res) => {
				setAnalyticsData(res);

				// Extract unique warehouses from the stock_by_warehouse data
				if (res.stock_by_warehouse && res.stock_by_warehouse.length > 0) {
					const warehouseOptions = [
						{ value: 'all', label: 'All Warehouses' },
						...res.stock_by_warehouse.map(item => ({
							value: item.warehouse,
							label: item.warehouse || 'Unknown Warehouse'
						}))
					];
					setWarehouses(warehouseOptions);
				}

				// Update last sync time
				setLastSyncTime(new Date().toLocaleString());
			})
			.catch((error) => {
				NotificationManager.error(
					error?.message || 'Something went wrong!',
					'Error',
					3000
				)
			})
	}

	const handleRefresh = () => {
		loadAnalyticsData();
	}

	return (
		<div className="flex flex-col h-full overflow-y-auto p-6">
			<div className="w-full flex flex-wrap justify-end items-center my-5 gap-3">
				<div className="flex justify-center gap-1 items-end mr-auto">
					<div className="mt-1 text-[13px] font-medium">
						<span className="font-bold">Last sync: </span>{lastSyncTime}
					</div>
					<RefreshOutlined onClick={handleRefresh} className='cursor-pointer' />
				</div>

				<div>
					<WarehouseFilter
						warehouses={warehouses}
						onWarehouseChange={setSelectedWarehouse}
					/>
				</div>

				<div>
					<BrandFilter brands={brands} onBrandChange={setStockOverTimeBrand} />
				</div>
			</div>

			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
				{dataBlocks(analyticsData?.block_data).map((item, index) => (
					<div className="revenue-block" key={index}>
						<div className="flex items-center gap-2">
							<span>{item.icon}</span>
							<span className="title">{item.title}</span>
						</div>
						<span className="value">{item.value}</span>
					</div>
				))}
			</div>

			<div className="mt-12 grid md:grid-cols-2 grid-cols-1 gap-6">
				<StockOverTime
					brands={brands}
					stock_data={analyticsData?.stocks_over_time || []}
					onBrandChange={setStockOverTimeBrand}
				/>
				<ProductDistribution
					data={analyticsData?.productDistributionBrand || []}
				/>
				<WarehouseStockDistribution
					data={analyticsData?.stock_by_warehouse || []}
				/>
				<div className="grid grid-cols-1 gap-6">
					<LowStockProducts
						brands={brands}
						data={analyticsData?.lowStockProducts || []}
					/>
					<TopStockProducts
						brands={brands}
						data={analyticsData?.topStockProducts || []}
					/>
				</div>
			</div>
		</div>
	)
}

export default RetailAnalyticDashboard